import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'split',
    standalone: false
})
export class SplitPipe implements PipeTransform {
  transform(input: string, sep = ' '): string[] {
    return input.split(sep);
  }
}
